import { render, staticRenderFns } from "./AccountTypeExtends.vue?vue&type=template&id=18b1fb6c"
import script from "./AccountTypeExtends.vue?vue&type=script&lang=js"
export * from "./AccountTypeExtends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports